$(".slider-2").slick({
  centerMode: true,
  centerPadding: "false",
  autoplay: false, //自動的に動き出すか。初期値はfalse。
  autoplaySpeed: 3000,
  infinite: true, //スライドをループさせるかどうか。初期値はtrue。
  arrows: true, // 矢印
  slidesToShow: 4, //スライドを画面に3枚見せる
  slidesToScroll: 1, //1回のスクロールで3枚の写真を移動して見せる
  prevArrow:
    '<div class="slick-prev-container slick-prev-next-container"><div class="slick-prev"></div></div>', //矢印部分PreviewのHTMLを変更
  nextArrow:
    '<div class="slick-next-container slick-prev-next-container"><div class="slick-next"></div></div>', //矢印部分NextのHTMLを変更
  responsive: [
    {
      breakpoint: 769, //モニターの横幅が769px以下の見せ方
      settings: {
        centerMode: false,
        slidesToShow: 4, //スライドを画面に2枚見せる
        slidesToScroll: 1, //1回のスクロールで2枚の写真を移動して見せる
      },
    },
    {
      breakpoint: 500, //モニターの横幅が500px以下の見せ方
      settings: {
        centerMode: false,
        centerPadding: "false",
        infinite: false,
        slidesToShow: 2, //スライドを画面に2枚見せる
        slidesToScroll: 1, //1回のスクロールで2枚の写真を移動して見せる
      },
    },
  ],
});
